
import * as bootstrap from "bootstrap";
(window as any).bootstrap = bootstrap;


import TomSelect from "tom-select";
(window as any).TomSelect = TomSelect;

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
tooltipTriggerList.forEach(el => {
    new bootstrap.Tooltip(el);
});

const $coverToggle = $("#includeCoverPage");
const $coverFields = $("#coverPageFields");

function toggleCoverFields() {
    if ($coverToggle.is(":checked")) {
        $coverFields.removeClass("d-none");
    } else {
        $coverFields.addClass("d-none");

        // Optional: clear values if unchecked
        $coverFields.find("input, textarea, select").val("");
    }
}

$coverToggle.on("change", toggleCoverFields);

// Run once on load (important for validation errors / reloads)
toggleCoverFields();